import { Directive, HostListener, Input } from '@angular/core';

@Directive({
  selector: '[bmEventBreak]'
})
export class EventBreakDirective {

  @Input('bmEventBreak') isStrict: boolean;

  constructor() {}

  @HostListener('mousedown' , ['$event'])

  breakMouseDownBubbling(event: MouseEvent) {

    this.isStrict ?
    event.stopImmediatePropagation() :
    event.stopPropagation();
  }

  @HostListener('click' , ['$event'])

  breakClickBubbling(event: MouseEvent) {

    this.isStrict ?
    event.stopImmediatePropagation() :
    event.stopPropagation();
  }

}
